<script lang="ts" setup>
import { useEventGuestsQuery } from '@/enitites/event/api/queries'
import { useImage } from '@/shared/composables/image'
import { IEventEdit } from '@/enitites/event'

const props = defineProps<{
  eventData: IEventEdit
}>()

const { data: guests, isLoading: isLoadingGuests } = useEventGuestsQuery(props.eventData.id)
const { getAvatar } = useImage()
</script>

<template>
  <div class="event-guest-list-total">
    <div
      v-if="isLoadingGuests"
      class="loading-state"
    >
      Loading guests...
    </div>

    <div
      v-else-if="!guests || guests.length === 0"
      class="empty-state"
    >
      <p class="empty-message">No guests added yet</p>
    </div>

    <div
      v-else
      class="guests-display"
    >
      <div
        v-for="guest in guests"
        :key="guest.id"
        class="guest-item"
      >
        <div class="guest-avatar-info">
          <v-avatar
            class="guest-avatar"
            size="40"
          >
            <img
              :alt="guest.assignedTo?.dancerName || 'Guest'"
              :src="getAvatar(guest.assignedTo?.avatar || '', 100)"
            />
          </v-avatar>
          <div class="guest-details">
            <span class="guest-name">
              {{ guest.assignedTo?.dancerName || 'Guest' }}
            </span>
            <span class="guest-added-date">
              {{ new Date(guest.addedAt).toLocaleDateString() }}
            </span>
          </div>
        </div>
        <span class="guest-label">
          {{ guest.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.event-guest-list-total {
  max-width: 400px;
  margin: 0 auto;

  .loading-state,
  .empty-state {
    text-align: center;
    padding: 20px;
    color: var(--color-grey-300);
  }

  .empty-message {
    margin: 0;
    font-style: italic;
  }

  .guests-display {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .guest-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;

      .guest-avatar-info {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
        min-width: 0;

        .guest-details {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;

          .guest-name {
            font-weight: 500;
            color: var(--color-dark-800);
            font-size: 14px;
            line-height: 1.2;
          }

          .guest-added-date {
            font-size: 12px;
            color: var(--color-grey-300);
            white-space: nowrap;
          }
        }
      }

      .guest-label {
        color: var(--color-dark-800);
        font-size: 14px;
        line-height: 1.2;
      }
    }
  }
}
</style>
